import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { useAuthState } from '@percent/cause-dashboard/common/hooks/useAuthState/useAuthState'
import { useMutation } from '@percent/cause-dashboard/common/hooks'
import { LoginWithRecoveryCode } from './LoginWithRecoveryCode'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'

export function LoginWithRecoveryCodeContainer() {
  const {
    authState: { user }
  } = useAuthState()
  const { authService } = useServices()
  const navigate = useNavigate()
  const [isRecoveryCodeConfirmed, setIsRecoveryCodeConfirmed] = useState(false)
  const { state } = useLocation()
  const [{ errorMessage, isLoading, data: response, success }, { apiFunc: loginFunc, setErrorMessage }] = useMutation(
    authService.loginWithRecoveryCode,
    () => {
      localStorage.authState = JSON.stringify({
        isAuthorised: true,
        isAuthorising: false
      })
    }
  )

  useEffect(() => {
    if (!state?.password) {
      navigate('/signin')
    }
  }, [state, navigate])

  useEffect(() => {
    if (success || user?.twoFaBackupCode) {
      setIsRecoveryCodeConfirmed(true)
    }
  }, [success, user])

  return (
    <LoginWithRecoveryCode
      userData={response?.data?.data}
      errorMessage={errorMessage}
      isLoading={isLoading}
      loginFunc={loginFunc}
      isRecoveryCodeConfirmed={isRecoveryCodeConfirmed}
      setErrorMessage={setErrorMessage}
    />
  )
}
